import ComparePage from './CompareLayout';
import { CAYDA, ADV } from './caydaFacts';

const VsUserback = () => (
  <ComparePage
    slug="userback"
    competitor="Userback"
    description="Userback alternative: Cayda pins feedback on your live site with nothing visible to visitors, unlimited sites, and a free plan that never locks."
    hero="The Userback alternative that never shows your visitors a button."
    intro="Userback puts a launcher on your page so the public can send reports, then sells you seats, projects and add-ons around it. Cayda keeps the feedback layer private to your team, runs on every site you own for one price, and starts at $9 with a free plan that never expires."
    verdict={[
      { label: 'Starting price', cayda: '$9/mo', other: '$29/mo' },
      { label: 'Free plan', cayda: 'No expiry', other: 'Locks after 7 days' },
      { label: 'Sites on paid plans', cayda: 'Unlimited', other: '5 on Team, 25 on Business' },
      { label: 'Visible to visitors', cayda: 'Never', other: 'Launcher by default' },
    ]}
    advantages={[
      { ...ADV.invisible, body: 'Nothing renders for your audience on any plan. Userback hides its launcher only through its JavaScript SDK on the Business tier; Cayda has nothing to hide because the layer exists only for authenticated team members and invited guests.' },
      { ...ADV.pricing, body: 'A base fee covers you; each accepted teammate is $5 to $6. Paid plans have no site or project cap, so an agency with fifteen client sites pays the same as a studio with one. Userback caps projects at 5, 25 and 50 by tier.' },
      { ...ADV.dashboard, body: 'Kanban and list views, filters by status, priority, assignee and note type, bulk actions, threaded comments, an activity feed and CSV export on Pro. Userback holds export back to its $79 Business plan.' },
      ADV.realSite,
    ]}
    cost={{
      note: 'Annual billing, per month. Userback pricing from userback.io/pricing, September 2026.',
      scenarios: [
        { label: 'Solo freelancer', detail: 'unlimited sites', cayda: 9, other: 29, caydaPlan: 'Pro, owner covered', otherPlan: 'Team, 5 projects' },
        { label: 'Three people, Jira', detail: 'plus Asana, Linear, screen recording, guests', cayda: CAYDA.teamPrice(2), other: 29, caydaPlan: 'Team + 2 members', otherPlan: 'Team, 5 projects' },
        { label: 'Agency, five people, fifteen sites', detail: 'Jira and Slack', cayda: CAYDA.teamPrice(4), other: 79, caydaPlan: 'Team + 4 members', otherPlan: 'Business, 25 projects' },
      ],
    }}
    diagram="widget"
    features={{
      note: 'Cayda plan names in the Cayda column. Userback details from userback.io/pricing, September 2026.',
      rows: [
        ['Free plan', CAYDA.free, '2 seats · 2 projects · locks after 7 days'],
        ['Entry paid plan', CAYDA.pro, '$29 · 5 seats · 5 projects'],
        ['Jira, Asana, Linear', CAYDA.team, 'Team ($29)'],
        ['Slack', 'Pro', 'Free'],
        ['Websites on paid plans', 'Unlimited', '5 / 25 / 50 by tier'],
        ['Visible to site visitors', 'Never', 'Launcher by default'],
        ['Runs on your live domain', true, true],
        ['Auto screenshot, browser, OS, viewport', true, true],
        ['Screen recording', 'Team', 'All plans'],
        ['Kanban + list dashboard, bulk actions', true, 'Dashboard'],
        ['Client / guest reviewers', 'Team, no member fee', 'Free reporters'],
        ['CSV export', 'Pro', 'Business ($79)'],
        ['WordPress plugin, Shopify app', true, 'WordPress plugin'],
      ],
    }}
    approach={[
      'Userback is a customer feedback platform: a visible widget for end users, surveys, a feature request portal sold as an add-on, and AI categorisation on the upper tiers. Plans are sized by seats and projects, from two projects on the free plan to fifty on Business Plus, and the free tier locks each piece of feedback seven days after it is submitted.',
      'Cayda is the feedback layer for the team that builds and maintains the site. It is private by design, it captures the context of the real page, it triages in a board, and it pushes to Slack, Jira, Asana and Linear, without counting your sites or metering your visitors.',
    ]}
    bottomLine={[
      'If the people leaving feedback are your team and your clients, and the sites you review are many, Cayda costs less, stays invisible on production, and does not lock your notes behind a timer. Add a site free and see it on your own pages.',
    ]}
  />
);

export default VsUserback;
